import {
  mapToCancellationExpense,
  mapToAdditionalExpense,
  mapToSnowSportAdditionalItemExpense,
  mapToCancellationRefundCompensationItem,
} from './expenseMapper';
import { mapClaimingFor, nullItem } from './sharedMapper';
import {
  stepSnowSportsExpenseLookup as expenseLookup,
  emptyClaimCode,
} from './claimCodeMapper';

function mapToParentSection() {
  return {};
}

function mapToQuestionnaire(data, claimCode) {
  const questionnaire = [];
  const entries = Object.entries(data);
  const excludedEntries = [
    'claimingFor',
    'cancellationExpenses',
    'additionalExpenses',
    'additionalItems',
    'snowPrepaidCancellationExpenses',
    'snowResortCancellationExpenses',
    'snowPrepaidAdditionalExpenses',
    'snowResortAdditionalExpenses',
    'snowSportEquipment',
    'snowEquipmentReplacementHire',
    'snowSportEquipmentAdditionalItems',
    'snowEquipmentReplacementHireAdditionalItems',
  ];
  entries.forEach(([property, value]) => {
    if (excludedEntries.indexOf(property) < 0) {
      questionnaire.push({
        question: `section9.${property}`,
        answer: value,
        claimTypeCode: claimCode,
      });
    }
  });

  const snowSportEquipment = mapExpenseDetailToQuestionnaire('snowSportEquipment', data.snowSportEquipment, claimCode);
  const snowEquipmentReplacementHire = mapExpenseDetailToQuestionnaire('snowEquipmentReplacementHire', data.snowEquipmentReplacementHire, claimCode);

  return [...questionnaire, ...snowSportEquipment, ...snowEquipmentReplacementHire];
}

function getSnowSportEquipmentClaimCode(data) {
  if (data.areYouClaimingForSnowSportEquipment === 'true') {
    return expenseLookup.areYouClaimingForSnowSportEquipment;
  }
  return emptyClaimCode;
}

function getSnowEquipmentReplacementClaimCode(data) {
  if (data.areYouClaimingForSnowEquipmentReplacementHire === 'true') {
    return expenseLookup.areYouClaimingForSnowEquipmentReplacementHire;
  }
  return emptyClaimCode;
}

function getSnowPrepaidClaimCode(data) {
  if (data.areYouClaimingForSnowPrepaidExpenses === 'true') {
    return expenseLookup.areYouClaimingForSnowPrepaidExpenses;
  }
  return emptyClaimCode;
}

function getSnowResortClosureClaimCode(data) {
  if (data.areYouClaimingForSnowResortClosure === 'true') {
    return expenseLookup.areYouClaimingForSnowResortClosure;
  }
  return emptyClaimCode;
}

function mapToExpenses(data) {
  const equipmentClaimCode = getSnowSportEquipmentClaimCode(data);
  const equipmentReplacementClaimCode = getSnowEquipmentReplacementClaimCode(data);
  const prepaidClaimCode = getSnowPrepaidClaimCode(data);
  const resortClosureClaimCode = getSnowResortClosureClaimCode(data);
  // let expenses = [];
  const snowPrepaidCancellationExpenses = (prepaidClaimCode === emptyClaimCode) ? [] : data.snowPrepaidCancellationExpenses.map(
    mapToCancellationExpense, prepaidClaimCode,
  );
  const snowResortCancellationExpenses = (resortClosureClaimCode === emptyClaimCode) ? [] : data.snowResortCancellationExpenses.map(
    mapToCancellationExpense, resortClosureClaimCode,
  );
  const snowPrepaidRefundExpenses = (prepaidClaimCode === emptyClaimCode) ? [] : data.snowPrepaidCancellationExpenses.map(
    mapToCancellationRefundCompensationItem, prepaidClaimCode,
  ).filter(nullItem);
  const snowResortRefundExpenses = (resortClosureClaimCode === emptyClaimCode) ? [] : data.snowResortCancellationExpenses.map(
    mapToCancellationRefundCompensationItem, resortClosureClaimCode,
  ).filter(nullItem);

  const snowPrepaidAdditionalExpenses = (prepaidClaimCode === emptyClaimCode || data.areThereAnyAdditionalExpensesToBeClaimedSnowPrepaid !== 'true') ? [] :
    data.snowPrepaidAdditionalExpenses.map(
      mapToAdditionalExpense, prepaidClaimCode,
    );
  const snowResortAdditionalExpenses = (resortClosureClaimCode === emptyClaimCode || data.areThereAnyAdditionalExpensesToBeClaimedSnowResort !== 'true') ? [] :
    data.snowResortAdditionalExpenses.map(
      mapToAdditionalExpense, resortClosureClaimCode,
    );
  const snowSportEquipmentAdditionalItems = (equipmentClaimCode === emptyClaimCode) ? [] : data.snowSportEquipmentAdditionalItems.map(
    mapToSnowSportAdditionalItemExpense, equipmentClaimCode,
  );
  const snowEquipmentReplacementHireAdditionalItems = (equipmentReplacementClaimCode === emptyClaimCode) ? [] : data.snowEquipmentReplacementHireAdditionalItems.map(
    mapToSnowSportAdditionalItemExpense, equipmentReplacementClaimCode,
  );

  const expenses = [
    ...snowPrepaidCancellationExpenses,
    ...snowResortCancellationExpenses,
    ...snowPrepaidRefundExpenses,
    ...snowResortRefundExpenses,
    ...snowPrepaidAdditionalExpenses,
    ...snowResortAdditionalExpenses,
    ...snowSportEquipmentAdditionalItems,
    ...snowEquipmentReplacementHireAdditionalItems,
  ];

  return expenses;
}

function mapExpenseDetailToQuestionnaire(expensePrefix, expenseDetail, claimCode) {
  const questionnaire = [];
  const entries = Object.entries(expenseDetail);
  entries.forEach(([property, value]) => {
    questionnaire.push({
      question: `section19.${expensePrefix}.${property}`,
      answer: (property === 'claimingFor') ? mapClaimingFor(value) : value,
      claimTypeCode: claimCode,
    });
  });

  return questionnaire;
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepSnowSportsDataMapper.js